import React, { useEffect, useState } from 'react';

import api from '../../../config/api';
import configData from '../../../config/config.js';
import language from '../utils/language';

import { Panel, PanelBody } from '../../../components/panel/panel.jsx';
import Chart from 'react-apexcharts';
import { useHistory } from 'react-router-dom';

import DataTable from 'react-data-table-component';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'react-datepicker/dist/react-datepicker.css';


export default function Dashboard(props) {

    // var translation = language();
    // console.log('dashboard translation', translation)

    const [reload, setReload] = useState(false);

    const today = new Date();
    // const firstDayWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 1).toLocaleDateString();
    // const lastDayWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 7).toLocaleDateString();
    const firstDayMonth = new Date(today.getFullYear(), today.getMonth(), 1).toLocaleDateString();
    const lastDayMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).toLocaleDateString();
    const [dateRange, setDateRange] = useState({ startDate: firstDayMonth, endDate: lastDayMonth });

    const [classpie, setClasspie] = useState('col-md-6 offset-3');
    const [year, setYear] = useState(today.getFullYear());
    const [yearProcess, setYearProcess] = useState(today.getFullYear());

    
    const translations = language();
    // console.log('dashboard translations', translations)

    const [barChart, setBarChart] = useState({
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#ffffff'],
                    
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            colors: ['#306BAC'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            title: {
                text: translations.dashboard.charts.processes_barchart_quarter.title,
                align: 'center'
            },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });

    const [barChartAnual, setBarChartAnual] = useState({
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#ffffff']
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            // colors: ['#0099ff'],
            
            colors: ['#ee7578'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            // title: {
            //     text: translations.dashboard.charts.processes_barchart_anual.title,
            //     align: 'center'
            // },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });

    const [pieChartDistrict, setPieChartDistrict] = useState({
        options: {
            chart: {
                type: "pie",
                id: "pieChartDistrict",
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                },
                height: 150,
            },
            legend: {
                position: 'bottom'
            },
            
            title: {
                text: translations.dashboard.charts.processes_district.title
            }
        },
        series: []
    });

    const [pieChartCounty, setPieChartCounty] = useState({
        options: {
            chart: {
                id: "pieChartCounty",
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                },
                height: 150,
                type: 'pie',
            },
            legend: {
                position: 'bottom'
            },
            dataLabels: {
                dropShadow: {
                    enabled: false,
                    top: 1,
                    left: 1,
                    blur: 1,
                    opacity: 0.45
                }
            },
            plotOptions: {
                pie: {
                    customScale: 1.1
                }
            },

            labels: [],
            title: {
                text: translations.dashboard.charts.processes_county.title
                
            }
        },
        series: []
    });

    const [pieChartAcompanhamento, setPieChartAcompanhamento] = useState({
        options: {
            chart: {
                id: "pieChartAcompanhamento",
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                },
                height: 150,
                type: 'pie',
                width: '100%',
                zoom: {
                    enabled: true,
                    type: 'x',  
                    autoScaleYaxis: false,
                }
            },
            legend: {
                position: 'bottom'
            },
            dataLabels: {
                dropShadow: {
                    enabled: false,
                    top: 1,
                    left: 1,
                    blur: 1,
                    opacity: 0.45
                },
                
            },
            plotOptions: {
                pie: {
                    customScale: 1
                }
            },

            labels: [],
            title: {
                text: translations.dashboard.charts.processes_acompanhamento.title

            }
        },
        series: []
    });

    const [barChartMonth, setBarChartMonth] = useState({
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#2c2e30', 'transparent']
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            // colors: ['#0099ff'],
            
            colors: ['#c8d5b9'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            // title: {
            //     text: translations.dashboard.charts.processes_barchart_month.title,
            //     align: 'center'
            // },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });

    const [barChartNewYear, setBarChartNewYear] = useState({
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#2c2e30', 'transparent']
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            // colors: ['#0099ff'],
            
            colors: ['#98b9f2'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            // title: {
            //     text: translations.dashboard.charts.processes_barchart_month.title,
            //     align: 'center'
            // },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });
    const [barChartNewMonth, setBarChartNewMonth] = useState({

        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#2c2e30', 'transparent']
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            // colors: ['#0099ff'],
            
            colors: ['#918ef4'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            // title: {
            //     text: translations.dashboard.charts.processes_barchart_month.title,
            //     align: 'center'
            // },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });
    const [barChartCeasedYear, setBarChartCeasedYear] = useState({
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#ffffff', 'transparent']
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            // colors: ['#0099ff'],
            
            colors: ['#646f58'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            // title: {
            //     text: translations.dashboard.charts.processes_barchart_month.title,
            //     align: 'center'
            // },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });
    const [barChartCeasedMonth, setBarChartCeasedMonth] = useState({

        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 0,
                style: {
                    fontSize: '13px',
                    colors: ['#2c2e30', 'transparent']
                }
            },
            // colors: ['#0099ff', '#ff0000'],
            // colors: ['#0099ff'],
            
            colors: ['#dbebc0'],
            stroke: {
                show: true,
                width: 1,
                colors: ['#ffffff']
            },
            // title: {
            //     text: translations.dashboard.charts.processes_barchart_month.title,
            //     align: 'center'
            // },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetY: -10,
                horizontalAlign: 'right',
                floating: true,
            }
        },
        series: []
    });
    const [barChartStackedYear, setBarChartStackedYear] = useState({

        options: {
            chart: {
                height: 350,
                type: 'bar',
                stacked: true,
                // stackType: '100%'
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        position: 'top',
                    },
                }
            },
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            },
          
            stroke: {
                width: 1,
                colors: ['#ffffff']
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                    return val 
                    }
                }
            },
            title: {
                text: translations.dashboard.charts.processes_barchart_active_data_activantion.title,
                align: 'center'
            },
            grid: {
                row: {
                    colors: ['rgba(182, 194, 201, 0.1)', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
                axisBorder: {
                    show: true,
                    color: 'rgba(182, 194, 201, 0.5)',
                    height: 1,
                    width: '100%',
                    offsetX: 0,
                    offsetY: -1
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#b6c2c9',
                    height: 6,
                    offsetX: 0,
                    offsetY: 0
                }
            },
            // yaxis: {
            // 	labels: {
            // 		formatter: function(val, index) {
            // 			return val.toFixed(0);
            // 		}
            // 	}
            // },
            legend: {
                show: true,
                position: 'top',
                offsetX: 40,
                horizontalAlign: 'center',
                floating: true,
            }
        },
        series: []
    });


    const pickerOptions = {
        format: "DD/MM/YYYY",
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        daysOfWeek: [translations.dates.daysOfWeek],
        monthNames: [translations.dates.months]
    
    }
    
    const [allprocesses, setAllProcesses] = useState([]);
    const [applied_measures, setAppliedMeasures] = useState([]);
    const [with_extension, setWithExtension] = useState([]);
    const [applied_measures_list, setAppliedMeasuresList] = useState([]);
    // const [measures_transit_year, setMeasuresTransitYear] = useState({});
    const [measures_transit_year_list, setMeasuresTransitYearList] = useState([]);
    const [active_measures, setActiveMeasures] = useState([]);
    // const [active_measures_list, setActiveMeasuresList] = useState({});

    function iniciate(dates) {
        // getdataCharts({ startDate: firstDayMonth, endDate: lastDayMonth });

            getdata_medidasaplicadas(dates);
            getdata_medidasaplicadastransitamano(dates);
            getdata_medidasaporano(dates);
            getdata_medidasaporquadrimestre(dates);
            getdata_piecharts(dates);
            getdata_allcount(dates);
            //2025.03.03
            getdata_medidasPorMes(dates);
            getdata_processosNovos(dates);
            getdata_processosAtivos();
            getdata_processosCeased();
            
    }

    useEffect(() => {
        // console.log('props useeffect', props)
        iniciate({ startDate: firstDayMonth, endDate: lastDayMonth });
            
     
    }, []);

    async function getdata_allcount(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:0,
                    startDate: daterange.startDate,
                    endDate: daterange.endDate,
                    
                    }
            }).then((response) => {

                setAllProcesses(response.data?.processes || []);
                setWithExtension(response.data?.processes_extension || []);
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }
    async function getdata_medidasaplicadas(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:1,
                    startDate: daterange.startDate,
                    endDate: daterange.endDate,
                    
                    }
            }).then((response) => {
                // console.log('getdata_medidasaplicadas response', response)
                setAppliedMeasures(response.data?.applied_measures || []);
                setAppliedMeasuresList(response.data.applied_measures?.list_applied_date || []);
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }
    async function getdata_medidasaplicadastransitamano(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:2,
                    startDate: daterange.startDate,
                    endDate: daterange.endDate,
                    
                    }
            }).then((response) => {

                // setMeasuresTransitYear(response.data.measures_transit_year)
                setMeasuresTransitYearList(response.data?.measures_transit_year.list || [])
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }
    async function getdata_medidasaporano(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:3,
                    startDate: daterange.startDate,
                    endDate: daterange.endDate,                
                    }
            }).then((response) => {
                // console.log('getdata_medidasaporano response.data',response.data);
                setActiveMeasures(response.data?.active_measures || []);

                setBarChartAnual(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart_anual.data?.categories || [],
                        }
                    },
                    series: [{
                        data: response.data.barchart_anual.data.series?.data || [],
                        name: response.data.barchart_anual.data.series?.name || ''
                    }]

                }));
                
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }
    
    let chartData=[];
    let chartdataYear=[];
    let chartdataMonth=[];
    async function getdata_medidasPorMes(daterange) {
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:6
                    }
            }).then((response) => {
                chartData = response.data.barchart_anual?.chartdata || []
                
                let html = "<option value='0'>Selecionar Ano</option>"
                html+=Object.keys(chartData).map(el => {
                    return `<option value='${el}' ${(el==response.data.barchart_anual.year) ? 'selected' : ''}>${el}</option>`
                }).join("")
                document.getElementById("yearSelect").innerHTML = html;
                
                setYear(response.data.barchart_anual.year)
                
                setBarChartMonth(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart_anual.data?.categories || [],
                        }
                    },
                    series: [{
                        data: chartData[year],
                        // data: response.data.barchart_anual.data.series.data,
                        name: response.data.barchart_anual.data?.series.name || ''
                    }]

                }));
                
                document.getElementById("yearSelect").addEventListener("change", function () {
                    let selectedYear = this.value;
                    console.log('selectedYear',selectedYear);
                    console.log(chartData[selectedYear]);

                    setBarChartMonth(prevState => ({
                        ...prevState,
                        series: [{
                            name: prevState.series[0].name, // Keep name
                            data: chartData[selectedYear] // Update data
                        }]
                    }));

                });
                
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
    }

    async function getdata_processosNovos(daterange) {
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:8
                    }
            }).then((response) => {
                chartdataMonth = response.data.barchart.chartdataMonth
                chartdataYear = response.data.barchart.chartdataYear
                
                if(document.getElementById("yearProcessSelect")){
                    let html = "<option value='0'>Selecionar Ano</option>"
                    html+=response.data.barchart.data_year.categories.map(el => {
                        return `<option value='${el}' ${(el==response.data.barchart.year) ? 'selected' : ''}>${el}</option>`
                    }).join("")
                    document.getElementById("yearProcessSelect").innerHTML = html;
                }
                
                setYearProcess(response.data.barchart.year)
                
                setBarChartNewYear(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart.data_year?.categories || [],
                        }
                    },
                    series: [{
                        data: chartdataYear,
                        name: response.data.barchart.data_year?.series.name || ''
                    }]

                }));
                setBarChartNewMonth(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart.data_month?.categories || [],
                        }
                    },
                    series: [{
                        data: chartdataMonth[yearProcess],
                        name: response.data.barchart.data_month?.series.name || ''
                    }]

                }));
                
                document.getElementById("yearProcessSelect").addEventListener("change", function () {
                    let selectedYear1 = this.value;
                    setBarChartNewMonth(prevState => ({
                        ...prevState,
                        series: [{
                            name: prevState.series[0].name, // Keep name
                            data: chartdataMonth[selectedYear1] // Update data
                        }]
                    }));

                });
                
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
    }
    
    let chartdataCeasedYear=[];
    let chartdataCeasedMonth=[];
    async function getdata_processosCeased() {
        // setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:9
                    }
            }).then((response) => {
                chartdataCeasedMonth = response.data.barchart?.chartdatadataCeasedMonth || 0
                chartdataCeasedYear = response.data.barchart?.chartdataCeasedYear || 0
                
                let html = "<option value='0'>Selecionar Ano</option>"
                html+=response.data.barchart.dataCeased_year.categories.map(el => {
                    return `<option value='${el}' ${(el==response.data.barchart.year) ? 'selected' : ''}>${el}</option>`
                }).join("")
                document.getElementById("yearProcessCeasedSelect").innerHTML = html;
                
                setYearProcess(response.data.barchart.year)
                
                setBarChartCeasedYear(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart.dataCeased_year?.categories || [],
                        }
                    },
                    series: [{
                        data: chartdataCeasedYear,
                        name: response.data.barchart.dataCeased_year?.series.name  || ''
                    }]

                }));
                setBarChartCeasedMonth(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart.dataCeased_month?.categories || [],
                        }
                    },
                    series: [{
                        data: chartdataCeasedMonth[barChartCeasedYear],
                        name: response.data.barchart.dataCeased_month.series?.name || ''
                    }]

                }));
                
                document.getElementById("yearProcessCeasedSelect").addEventListener("change", function () {
                    let selectedYear2 = this.value;
                    setBarChartCeasedMonth(prevState => ({
                        ...prevState,
                        series: [{
                            name: prevState.series[0].name, // Keep name
                            data: chartdataCeasedMonth[selectedYear2] // Update data
                        }]
                    }));

                });
                
                
            }).catch((err) => {
            console.log(err);
        });
        // setReload(false);
    }
    
    let [smallSlices,setSmallSlices]=useState([]);
    async function getdata_piecharts(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        let dtstart = '01/01/2025'
        let dtend = '31/03/2025'
        // let dtstart = daterange.startDate
        // let dtend = daterange.endDate
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:5,
                    startDate: dtstart,
                    endDate: dtend,
                    
                    }
            }).then((response) => {
               const totalD = response.data.piechart_district?.series.reduce((sum, val) => sum + val, 0) || 0;
               const dataLabels = response.data.piechart_district?.labels || []
               
               const dataSlice = response.data.piechart_district.series.map((val, i) => ({
                        label: dataLabels[i],
                        val,
                        percent: ((val / totalD) * 100).toFixed(2)
                    }))
                    .filter(item => item.percent < 2)
               
               setSmallSlices(dataSlice);

               setPieChartDistrict(prevState => ({
                    series: response.data.piechart_district?.series || [],
                    options: {
                        ...prevState.options,
                        labels: response.data.piechart_district?.labels || [],
                        dataLabels: {
                            enabled: true,
                            formatter: function (val, { seriesIndex, w }) {
                                const absolute = response.data.piechart_district.series[seriesIndex];
                                const percentage = val.toFixed(2);
                                if (percentage < 2) {
                                    return `${absolute}`;
                                }
                                else {
                                    return `${absolute} (${percentage}%)`;
                                }
                                
                            },
                            dropShadow: {
                                enabled: false,
                            },
                            textAnchor: 'start',
                            distributed: false,
                            offsetX: 250,
                            offsetY: 250,
                            style: {
                                fontSize: '14px',
                                fontFamily: 'Helvetica, Arial, sans-serif',
                                fontWeight: 'bold',
                               
                            },
                            
                        },
                        plotOptions: {
                            pie: {
                                customScale: 0.9,
                                
                            }
                        },
                        tooltip: {
                            y: {
                                formatter: (value, { seriesIndex, w }) => {
                                    
                                    const percent = ((value / totalD) * 100).toFixed(2);
                                    return `${value} (${percent}%)`;
                                }
                            }
                        },

                    },
                    
                }));

                // console.log('\n\n series.length',response.data.piechart_county.series,response.data.piechart_county.series.length);
                if(response.data.piechart_county.series.length>20) {
                    setClasspie('col-md-12')
                }else {
                    if(response.data.piechart_county.series.length>10) {
                        setClasspie('col-md-8 offset-2')
                    }
                }

                setPieChartCounty(prevState => ({
                    options: {
                        ...prevState.options,
                        labels: response.data.piechart_county?.labels || [],
                        
                    },
                    series: response.data.piechart_county?.series || [],
                }));

                setPieChartAcompanhamento(prevState => ({
                    options: {
                        ...prevState.options,
                        labels: response.data.piechart_acompanhamento?.labels || [],
                        // labels: response.data.piechart_acompanhamento.labels_custom
                        dataLabels: {   
                            dropShadow: {
                                enabled: false,
                            },
                            textAnchor: 'middle',
                            style: {
                                    fontSize:'20px'
                                },
                        },
                        plotOptions: {
                            pie: {
                                customScale: 0.8,
                                   
                            }
                        },
                        
                    },
                    series: response.data.piechart_acompanhamento?.series || [],
                }));
                
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }
    async function getdata_medidasaporquadrimestre(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:4,
                    startDate: daterange.startDate,
                    endDate: daterange.endDate,
                    
                    }
            }).then((response) => {
                
                let title = translations.dashboard.charts.processes_barchart_quarter.title + response.data.barchart_quarter.year;
                // console.log('title', title)
                setBarChart(prevState => ({
					options: {
						...prevState.options,
                        title: {
                            text : title
                        },
						xaxis: {
							...prevState.options.xaxis,
                            categories: response.data.barchart_quarter.data?.categories || [],
						}
					},
                    series: [{
                        data: response.data.barchart_quarter.data.series?.data || [],
                        name: response.data.barchart_quarter.data.series?.name || ''
                    }]
                    
				}));
                
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }

    let chartDataStacked=[];
    async function getdata_processosAtivos() {
        // console.log('getdataCharts', daterange)
        setReload(true);
        await api.get(configData.API + '/chartsdata', {
                params: {
                    n:7,
                    
                    }
            }).then((response) => {
                
                
                let title = translations.dashboard.charts.processes_barchart_active_data_activantion.title;
                chartDataStacked = response.data.barchart.data_year?.series || []
                

                setBarChartStackedYear(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart.data_year?.categories || [], 
                        }
                    },
                    series: chartDataStacked
               
                }));
                
                
            }).catch((err) => {
            console.log(err);
        });
        setReload(false);
            
    }


    function getdataCharts(daterange) {
        // console.log('getdataCharts', daterange)
        setReload(true);
        api.get(configData.API + '/chartsdata', {
                params: {
                    startDate: daterange.startDate,
                    endDate: daterange.endDate
                    }
            }).then((response) => {
                // console.log('response.data getdataCharts', response.data);
                // console.log('response.data getdataCharts', response.data.barchart_quarter);
            

                setPieChartDistrict(prevState => ({
                    options: {
                        ...prevState.options,
                        labels: response.data.piechart_district?.labels || [],
                    },
                    series: response.data.piechart_district?.series || [],
                }));

                setPieChartCounty(prevState => ({
                    options: {
                        ...prevState.options,
                        labels: response.data.piechart_county?.labels || [],
                    },
                    series: response.data.piechart_county?.series || [],
                }));

                setPieChartAcompanhamento(prevState => ({
                    options: {
                        ...prevState.options,
                        labels: response.data.piechart_acompanhamento?.labels || [],
                        // labels: response.data.piechart_acompanhamento.labels_custom
                    },
                    series: response.data.piechart_acompanhamento?.series || [],
                }));

                // console.log('response.data getdataCharts barchart_quarter', response.data.barchart_quarter);
                
                let title = translations.dashboard.charts.processes_barchart_quarter.title + response.data.barchart_quarter.year;
                // console.log('title', title)
                setBarChart(prevState => ({
					options: {
						...prevState.options,
                        title: {
                            text : title
                        },
						xaxis: {
							...prevState.options.xaxis,
                            categories: response.data.barchart_quarter.data?.categories || [],
						}
					},
                    series: [{
                        data: response.data.barchart_quarter.data.series?.data || [],
                        name: response.data.barchart_quarter.data.series?.name || ''
                    }]
                    
				}));

                setBarChartAnual(prevState => ({
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: response.data.barchart_anual.data?.categories || [],
                        }
                    },
                    series: [{
                        data: response.data.barchart_anual.data.series?.data || [],
                        name: response.data.barchart_anual.data.series?.name || ''
                    }]

                }));
  

            setReload(false);
        }).catch((err) => {
            console.log(err);
        });

        
    }

    

    function clearFilter() {
        setDateRange({ startDate: firstDayMonth, endDate: lastDayMonth });
        getdataCharts({ startDate: firstDayMonth, endDate: lastDayMonth });
    }

    function handleFilterDateRange(event, picker) {
        // console.log('picker', picker)
        const dates = {
            startDate: picker.startDate._d.toLocaleDateString(),
            endDate: picker.endDate._d.toLocaleDateString()
        }

        // console.log('picker', dates)

        setDateRange(dates);
        iniciate(dates);
        
    }

    // function manageProcess(id) {
    //     console.log('manageProcess', id);

    //     // toggleModal(0);
    //     history.push('/app/view-process/' + id);

    // }


    const paginationComponentOptions = {
		rowsPerPageText: 'Registos por Página',
		rangeSeparatorText: 'de',
		selectAllRowsItem: true,
		selectAllRowsItemText: 'Todos',
		// noRowsPerPage: 10
	};

    const tableColumns = [
        // {
        //     name: 'Estado',
        //     selector: 'state',
        //     width: 10,
        //     sortable: true,
        //     center: true,
        //     // className: 'text-center'
        // },
        {
            name: translations['table_processes'].num_order,
            selector: 'num_order',
            sortable: true,
            center: true,
            wrap:true,
            width: 40,
            // cell: row => <center>
            //     {<a href="#" onClick="() => manageProcess(`${row.id}`)">row.num_order</a>}
            // </center>,
        },
        {
            name: translations['table_processes'].litigation,
            selector: 'litigation',
            sortable: true,
            center: true,
            wrap:true,
            width: 10
        },
        // {
        //     name: translations['table_processes'].birth_date,
        //     selector: 'birth_date',
        //     sortable: true,
        //     center: true,
        //     width: 10
        // },
        {
            name: translations['table_processes'].age,
            selector: 'age',
            sortable: true,
            center: true,
            width: 10
        },
        // {
        //     name: translations['table_processes'].gender,
        //     selector: 'gender',
        //     sortable: true,
        //     center: true,
        // },
        {
            name: translations['table_processes'].activation_date_month,
            selector: 'activation_date_month',
            sortable: true,
            center: true,
            width: 10
        },
        {
            name: translations['table_processes'].activation_date_year,
            selector: 'activation_date_year',
            sortable: true,
            center: true,
            width: 10
        },
        
        // {
        //     name: translations['table_processes'].created_at,
        //     selector: 'createat',
        //     sortable: true,
        //     center: true,
        //     width: 30
        // }
    ];   

    const tableColumnsWithTerminationDate = [
        // {
        //     name: 'Estado',
        //     selector: 'state',
        //     width: 10,
        //     sortable: true,
        //     center: true,
        //     // className: 'text-center'
        // },
        {
            name: translations['table_processes'].num_order,
            selector: 'num_order',
            sortable: true,
            center: true,
            wrap:true,
            width: 40,
            // cell: row => <center>
            //     {<a href="#" onClick="() => manageProcess(`${row.id}`)">row.num_order</a>}
            // </center>,
        },
        {
            name: translations['table_processes'].litigation,
            selector: 'litigation',
            sortable: true,
            center: true,
            wrap:true,
            width: 10
        },
        // {
        //     name: translations['table_processes'].birth_date,
        //     selector: 'birth_date',
        //     sortable: true,
        //     center: true,
        //     width: 10
        // },
        {
            name: translations['table_processes'].age,
            selector: 'age',
            sortable: true,
            center: true,
            width: 10
        },
        // {
        //     name: translations['table_processes'].gender,
        //     selector: 'gender',
        //     sortable: true,
        //     center: true,
        // },
        {
            name: translations['table_processes'].termination_date,
            selector: 'termination_date',
            sortable: true,
            center: true,
            width: 10
        },
        {
            name: translations['table_processes'].activation_date_month,
            selector: 'activation_date_month',
            sortable: true,
            center: true,
            width: 10
        },
        {
            name: translations['table_processes'].activation_date_year,
            selector: 'activation_date_year',
            sortable: true,
            center: true,
            width: 10
        },

        // {
        //     name: translations['table_processes'].created_at,
        //     selector: 'createat',
        //     sortable: true,
        //     center: true,
        //     width: 30
        // }
    ];

  
    return (
        
        <>
            <div>
                <h1 className="page-header">
                    {translations['dashboard']['title']}
                <small>
                {/* {translations['dashboard']['title-small']}  */}
                </small></h1>

                <div className="row">
                    <div className="col-xl-12 col-md-12">
                        <div className="float-right m-b-20 m-r-20">
                            <DateRangePicker
                                locale={pickerOptions}
                                onApply={handleFilterDateRange}
                            >
                                <button className='btn btn-default btn-xm' ><i className="fa fa-calendar"></i>&nbsp;{`${dateRange.startDate} - ${dateRange.endDate}`}</button>
                           
                            </DateRangePicker>
                            {(dateRange.startDate !== firstDayMonth || dateRange.endDate !== lastDayMonth) && (
                                <button className='btn btn-default btn-xm' onClick={clearFilter}><i className="fa fa-times"></i>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-4 col-md-6">
                        <div className="widget widget-stats widget">
                            <div className="stats-icon stats-icon-lg"><i className="fas fa-balance-scale-left"></i></div>
                            <div className="stats-content">
                                <div className="stats-title">
                                    {translations['dashboard']['widgets']['month_processes'].title}
                                </div>
                                <div className="stats-number">{allprocesses.number_processes}</div>
                                <div className="stats-progress progress">
                                    <div className="progress-bar" style={{ width: allprocesses.perc+'%' }}></div>
                                </div>
                                <div className="stats-desc">{translations['dashboard']['widgets']['month_processes'].description} {allprocesses.all_processes}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="widget widget-stats">
                            <div className="stats-icon stats-icon-lg"><i className="fas fa-university"></i></div>
                            <div className="stats-content">
                                <div className="stats-title">{translations['dashboard']['widgets']['applied_measures'].title}
                                
                                </div>
                                <div className="stats-number">
                                    {applied_measures.perc_applied_date} %
                                    </div>
                                <div className="stats-progress progress">
                                    <div className="progress-bar" style={{ width: applied_measures.perc_applied_date + '%' }}>

                                    </div>
                                </div>
                                <div className="stats-desc">{translations['dashboard']['widgets']['applied_measures'].description} {applied_measures.total_applied_date}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="widget widget-stats">
                            <div className="stats-icon stats-icon-lg"><i className="far fa-clock"></i></div>
                            <div className="stats-content">
                                <div className="stats-title">{translations['dashboard']['widgets']['with_extension'].title}
                                </div>
                                <div className="stats-number">{with_extension.perc_extended} %</div>
                                <div className="stats-progress progress">
                                    <div className="progress-bar" style={{ width: with_extension.perc_extended + '%' }}></div>
                                </div>
                                <div className="stats-desc">{translations['dashboard']['widgets']['with_extension'].description} {with_extension.total}
                                </div>
                            </div>
                        </div>
                    </div>
                  

                </div>
            </div>
            <Panel>
                
                <PanelBody>
                    <div className="row">
                        {/* <div className="col-md-6">
                            <div className='panel panel-inverse'>
                                <div className='panel-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {pieChartDistrict.series.length > 0 && (
                                                <Chart 
                                                    type="pie" 
                                                    options={pieChartDistrict.options} 
                                                    series={pieChartDistrict.series} 
                                                />
                                                
                                            )}
                                            
                                            {(reload &&
                                                    <div className="panel-loader">
                                                        <span className="spinner-small"></span>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="col-md-6">
                            <div className='panel panel-inverse'>
                                <div className='panel-body'>
                                    <div className="row">
                                        <div className="col-md-12" style={{ position: 'relative' }}>
                                            {pieChartDistrict.series.length > 0 && (
                                                <Chart 
                                                    type="pie" 
                                                    options={pieChartDistrict.options} 
                                                    series={pieChartDistrict.series} 
                                                    
                                                />
                                                
                                            )}

                                            {/* <div style={{
                                                marginTop: '-250px', // pulls it visually inside the chart area
                                                textAlign: 'left',
                                                zIndex: 10,
                                                position: 'relative'
                                            }}>
                                                <div style={{ fontSize: '14px', color: '#667' }}>
                                                * Valores abaixo de 2% que podem não aparecer descritos no grafico
                                                 {smallSlices.map((item, i) => (
                                                    <div key={i} style={{ fontSize: '12px' }}>
                                                    <b>{item.label}:</b> {item.val} ({item.percent}%)
                                                    </div>
                                                ))}
                                                </div>
                                            </div> */}
                                            
                                            {(reload &&
                                                    <div className="panel-loader">
                                                        <span className="spinner-small"></span>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                      
                        <div className="col-md-6">
                            <div className='panel panel-inverse'>
                                <div className='panel-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {pieChartAcompanhamento.series.length > 0 && (
                                                <Chart type="pie" options={pieChartAcompanhamento.options} series={pieChartAcompanhamento.series} />
                                            )}
                                            {(reload &&
                                                    <div className="panel-loader">
                                                        <span className="spinner-small"></span>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className='panel panel-inverse'>
                                <div className='panel-body'>
                                    <div className="row">
                                        <div className={classpie}>
                                            {pieChartCounty.series.length > 0 && (
                                                <Chart type="pie" options={pieChartCounty.options} series={pieChartCounty.series} />
                                            )}
                                            {(reload &&
                                                    <div className="panel-loader">
                                                        <span className="spinner-small"></span>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </PanelBody>
            </Panel>

            <Panel>
                <PanelBody>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='panel panel-inverse'>
                                <div className='panel-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-12"><p style={{fontWeight: "bold",fontSize: "14px"}}> 
                                                       {translations['dashboard']['panel']['table_applied_measures'].title}</p>
                                                <DataTable
                                                    keys="id"
                                                    pagination
                                                    columns={tableColumns}
                                                    data={applied_measures_list}
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    noDataComponent={"Sem Registos"}
                                                />
                                                
                                            {(reload && 
                                                <div className="panel-loader">
                                                    <span className="spinner-small"></span>
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className='panel panel-inverse'>
                                <div className='panel-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-12"><p style={{ fontWeight: "bold", fontSize: "14px" }}>
                                             
                                                {translations['dashboard']['panel']['table_measures_transit_year'].title}</p>
                                                <DataTable
                                                    keys="id"
                                                    pagination
                                                    columns={tableColumnsWithTerminationDate}
                                                    data={measures_transit_year_list}
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    noDataComponent={"Sem Registos"}
                                                />
                                               
                                                {(reload &&
                                                    <div className="panel-loader">
                                                        <span className="spinner-small"></span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </PanelBody>
            </Panel>

            <Panel>
                <PanelBody>
                     <div className="row">
                        {/* processos ativos */}
                        <div className="col-md-6"> 
                            {barChart.series.length > 0 && (
                                <Chart type="bar" options={barChart.options} series={barChart.series} />
                            )}
                                
                        </div>

                        <div className="col-md-6">
                            {barChartStackedYear.series.length > 0 && (
                                <Chart type="bar" options={barChartStackedYear.options} series={barChartStackedYear.series} />
                            )}
                                
                        </div>

                    </div>
                </PanelBody>
            </Panel>

            <Panel>
                <PanelBody>
                    <div className="row chart_row">
                        <div className="row col-md-6 chart_title">
                            <label style={{ paddingBottom:'38px' }}>Processos Ativados (Anual) </label>
                            <div className="col-md-12">
                                {barChartAnual.series.length > 0 && (
                                    <Chart type="bar" options={barChartAnual.options} series={barChartAnual.series} />
                                )}

                            </div>

                        </div>

                        <div className="row col-md-6 chart_title">
                            <label>Processos Ativados (Mensal) </label>
                            <div className='col-md-12 ' style={{ display:'flex',justifyContent:'end' }}>
                                <label className='col-form-label chart_label' htmlFor='yearSelect'>Ano: </label>
                                <select className='form-control col-md-2 text-center' id="yearSelect"></select>

                            </div>
                            <div className="col-md-12">
                                {barChartMonth.series.length > 0 && (
                                <Chart type="bar" options={barChartMonth.options} series={barChartMonth.series} />
                                )}

                            </div>
                        </div>
                        
                    </div>
                </PanelBody>
            </Panel>

            <Panel>
                <PanelBody>
                    <div className="row chart_row">
                        <div className="row col-md-6 chart_title">
                            <label style={{ paddingBottom:'38px' }}>Processos Inseridos (Anual) </label>
                            <div className="col-md-12">
                                {barChartNewYear.series.length > 0 && (
                                    <Chart type="bar" options={barChartNewYear.options} series={barChartNewYear.series} />
                                )}

                            </div>

                        </div>

                        <div className="row col-md-6 chart_title">
                            <label>Processos Inseridos (Mensal)  </label>
                            <div className='col-md-12 ' style={{ display:'flex',justifyContent:'end' }}>
                                <label className='col-form-label chart_label' htmlFor='yearProcessSelect'>Ano: </label>
                                <select className='form-control col-md-2 text-center' id="yearProcessSelect"></select>

                            </div>
                            <div className="col-md-12">
                                {barChartNewMonth.series.length > 0 && (
                                    <Chart type="bar" options={barChartNewMonth.options} series={barChartNewMonth.series} />
                                )}

                            </div>
                        </div>
                        
                    </div>

                </PanelBody>
            </Panel>

            <Panel>
                <PanelBody>
                    <div className="row chart_row">
                        <div className="row col-md-6 chart_title">
                            <label style={{ paddingBottom:'38px' }}>Processos Cessados/recusa de equipamento (Anual) </label>
                            <div className="col-md-12">
                                {barChartCeasedYear.series.length > 0 && (
                                    <Chart type="bar" options={barChartCeasedYear.options} series={barChartCeasedYear.series} />
                                )}

                            </div>

                        </div>

                        <div className="row col-md-6 chart_title">
                            <label>Processos Cessados/recusa de equipamento (Mensal)  </label>
                            <div className='col-md-12 ' style={{ display:'flex',justifyContent:'end' }}>
                                <label className='col-form-label chart_label' htmlFor='yearProcessCeasedSelect'>Ano: </label>
                                <select className='form-control col-md-2 text-center' id="yearProcessCeasedSelect"></select>

                            </div>
                            <div className="col-md-12">
                                {barChartCeasedMonth.series.length > 0 && (
                                    <Chart type="bar" options={barChartCeasedMonth.options} series={barChartCeasedMonth.series} />
                                )}

                            </div>
                        </div>
                        
                    </div>

                </PanelBody>
            </Panel>
        </>

    )


}